import axios from "axios";
import { baseUrl } from "../util";

// Flow 34.1a - Material Usage
export const getAllMaterialUsage34_1aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/material-usage-34-1a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching material usage 34.1a:", error);
      setObjects([]);
    });
};

export const addMaterialUsage34_1aLCA = ({
  productId,
  material,
  qty,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/material-usage-34-1a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      material: material,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding material usage 34.1a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add material usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateMaterialUsage34_1aLCA = ({
  productId,
  rowId,
  material,
  qty,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/material-usage-34-1a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      material: material,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating material usage 34.1a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update material usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteMaterialUsage34_1aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/material-usage-34-1a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting material usage 34.1a:", error);
    });
};

// Flow 34.1b - Packaging Usage
export const getAllPackagingUsage34_1bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/packaging-usage-34-1b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching packaging usage 34.1b:", error);
      setObjects([]);
    });
};

export const addPackagingUsage34_1bLCA = ({
  productId,
  material,
  qty,
  supplier,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/packaging-usage-34-1b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      material: material,
      qty: qty || 0,
      supplier: supplier || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding packaging usage 34.1b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add packaging usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updatePackagingUsage34_1bLCA = ({
  productId,
  rowId,
  material,
  qty,
  supplier,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/packaging-usage-34-1b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      material: material,
      qty: qty || 0,
      supplier: supplier || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating packaging usage 34.1b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update packaging usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deletePackagingUsage34_1bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/packaging-usage-34-1b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting packaging usage 34.1b:", error);
    });
};

// Flow 34.1c - Water Usage
export const getAllWaterUsage34_1cLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/water-usage-34-1c-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching water usage 34.1c:", error);
      setObjects([]);
    });
};

export const addWaterUsage34_1cLCA = ({
  productId,
  water_type,
  supplier,
  qty,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/water-usage-34-1c-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      water_type: water_type,
      supplier: supplier || null,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding water usage 34.1c:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add water usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateWaterUsage34_1cLCA = ({
  productId,
  rowId,
  water_type,
  supplier,
  qty,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/water-usage-34-1c-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      water_type: water_type,
      supplier: supplier || null,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating water usage 34.1c:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update water usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteWaterUsage34_1cLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/water-usage-34-1c-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting water usage 34.1c:", error);
    });
};

// Flow 34.2a - Production Machines (with file upload support)
export const getAllProductionMachines34_2aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/production-machines-34-2a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching production machines 34.2a:", error);
      setObjects([]);
    });
};

export const addProductionMachines34_2aLCA = ({
  productId,
  machine_equipment,
  energy_type,
  qty,
  manual_co2e,
  documentation,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  formData.append("machine_equipment", machine_equipment || "");
  formData.append("energy_type", energy_type || "");
  formData.append("qty", qty || 0);
  if (manual_co2e !== null && manual_co2e !== undefined) {
    formData.append("manual_co2e", manual_co2e);
  }
  if (documentation) {
    formData.append("documentation", documentation);
  }

  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/production-machines-34-2a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding production machines 34.2a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add production machine",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateProductionMachines34_2aLCA = ({
  productId,
  rowId,
  machine_equipment,
  energy_type,
  qty,
  manual_co2e,
  documentation,
  objects,
  setObjects,
  use_swal = false,
}) => {
  const formData = new FormData();
  formData.append("machine_equipment", machine_equipment || "");
  formData.append("energy_type", energy_type || "");
  formData.append("qty", qty || 0);
  if (manual_co2e !== null && manual_co2e !== undefined) {
    formData.append("manual_co2e", manual_co2e);
  }
  if (documentation) {
    formData.append("documentation", documentation);
  }

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/production-machines-34-2a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating production machines 34.2a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update production machine",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteProductionMachines34_2aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/production-machines-34-2a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting production machines 34.2a:", error);
    });
};

// Flow 34.2b - Production Vehicles (with file upload support)
export const getAllProductionVehicles34_2bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/production-vehicles-34-2b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching production vehicles 34.2b:", error);
      setObjects([]);
    });
};

export const addProductionVehicles34_2bLCA = ({
  productId,
  production_vehicle,
  energy_type,
  qty,
  manual_co2e,
  documentation,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  formData.append("production_vehicle", production_vehicle || "");
  formData.append("energy_type", energy_type || "");
  formData.append("qty", qty || 0);
  if (manual_co2e !== null && manual_co2e !== undefined) {
    formData.append("manual_co2e", manual_co2e);
  }
  if (documentation) {
    formData.append("documentation", documentation);
  }

  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/production-vehicles-34-2b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding production vehicles 34.2b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add production vehicle",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateProductionVehicles34_2bLCA = ({
  productId,
  rowId,
  production_vehicle,
  energy_type,
  qty,
  manual_co2e,
  documentation,
  objects,
  setObjects,
  use_swal = false,
}) => {
  const formData = new FormData();
  formData.append("production_vehicle", production_vehicle || "");
  formData.append("energy_type", energy_type || "");
  formData.append("qty", qty || 0);
  if (manual_co2e !== null && manual_co2e !== undefined) {
    formData.append("manual_co2e", manual_co2e);
  }
  if (documentation) {
    formData.append("documentation", documentation);
  }

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/production-vehicles-34-2b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating production vehicles 34.2b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update production vehicle",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteProductionVehicles34_2bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/production-vehicles-34-2b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting production vehicles 34.2b:", error);
    });
};

// Flow 34.3 - Surplus Resources
export const getAllSurplusResources34_3LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-34-3-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources 34.3:", error);
      setObjects([]);
    });
};

export const addSurplusResources34_3LCA = ({
  productId,
  surplus_resource,
  disposal_method,
  qty,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-34-3-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource || null,
      disposal_method: disposal_method,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources 34.3:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add surplus resource",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResources34_3LCA = ({
  productId,
  rowId,
  surplus_resource,
  disposal_method,
  qty,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-34-3-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource || null,
      disposal_method: disposal_method,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating surplus resources 34.3:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update surplus resource",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResources34_3LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-34-3-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources 34.3:", error);
    });
};

// ============================================
// Flow 34: Get Total Impact for Custom Manufacturing
// ============================================

export const getCustomManufacturing34Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + productId + "/custom-manufacturing-34-totals",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.log(error);
      setTotals(null);
    });
};
